const activityRouter = [
  {
    path: '/activity/:id(\\d+)',
    name: 'ActivityDetail',
    component: () => import('@/views/activity/detail')
  }
]

export default activityRouter



// WEBPACK FOOTER //
// ./src/router/modules/activity.js